import * as React from 'react'
import intl from 'react-intl-universal'
import { Provider } from 'react-redux'
import { FeaturedMediaContainer } from '../Container/featuredMediaFormContainer'
import { IFeaturedMediaModalSFC } from './types'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const styles = require('../styles.scss')

const FeaturedMediaSFC = (props: IFeaturedMediaModalSFC): JSX.Element => {
  return (
    <Provider store={props.store}>
      <div className={'bulma--modal is-active ' + styles.modal}>
        {/* This component is not an accessible "dialog" so hard to apply specifc role here */}
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
        <div className="bulma--modal-background" onClick={props.hideModal} />
        <div className="bulma--modal-card featured-media-card">
          <header
            className="bulma--modal-card-head"
            style={{ backgroundColor: 'white' }}
          >
            <span className="bulma--modal-card-title">
              {intl.get('settings.featuredMedia.title')}
            </span>
          </header>
          <section className="bulma--modal-card-body">
            <div className="bulma--content">
              <FeaturedMediaContainer validator={props.validator} />
            </div>
          </section>
          <footer
            className="bulma--modal-card-foot"
            style={{ backgroundColor: 'white' }}
          >
            <div className="footer-buttons">
              <button
                type="button"
                className="btn btn-outline-primary mx-1 btn-override-primary"
                onClick={props.validateApply}
              >
                {intl.get('settings.featuredMedia.applyBtn')}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary mx-1"
                style={{
                  color: '#191b34',
                  borderColor: '#656a86',
                  border: '4px',
                }}
                onClick={props.hideModal}
              >
                {intl.get('settings.featuredMedia.cancelBtn')}
              </button>
            </div>
          </footer>
        </div>
      </div>
    </Provider>
  )
}

export default FeaturedMediaSFC
